module.exports = __webpack_public_path__ + "img/namsando.afb0caf3.jpg";